import {
  Checkbox,
  type CheckboxProps,
  FormErrorMessage,
  Stack,
  type StackProps,
  useCheckboxGroup,
} from "@chakra-ui/react";

type TOption = { label: string; value: string };

type TProps = StackProps & {
  options: TOption[];
  onChange: (val?: string[]) => void;
  error?: string;
  value?: string[];
  size?: CheckboxProps["size"];
};

export const CheckboxGroup: React.FC<TProps> = ({ options, onChange, error, value, size = "md", ...rest }) => {
  const { getCheckboxProps } = useCheckboxGroup({
    value: value ?? [],
    onChange: (next) => onChange(next.length ? (next as string[]) : undefined),
  });

  return (
    <Stack gap="2.5" my="2.5" {...rest}>
      {options.map(({ value: optionValue, label }) => (
        <Checkbox
          key={optionValue}
          _checked={{
            bg: "#D7DEF8",
            borderColor: "#7147BD",
          }}
          cursor="pointer"
          bg="white"
          width="100%"
          borderWidth="1px"
          borderRadius="5px"
          size={size}
          boxShadow="card"
          p="2.5"
          {...getCheckboxProps({ value: optionValue })}>
          {label}
        </Checkbox>
      ))}
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </Stack>
  );
};
